// extracted by mini-css-extract-plugin
export default {"boxDate":"DateCalendar_boxDate__ztj4E","iconBox":"DateCalendar_iconBox__ml5UX","iconCalendar":"DateCalendar_iconCalendar__B0nDG","dateNowe":"DateCalendar_dateNowe__e6UYH"};